/* eslint-disable unused-imports/no-unused-vars */
import { Middleware } from 'redux';
// import { signUpActions } from 'pages/sign-up/slice';
import { RootState } from '../interfaces';

const customMiddleware: Middleware<{}, RootState> = (store) => (
  next,
) => (action) => {
  switch (action.type) {
    // case signUpActions.signUp.type:
    //   next(action);
    //   break;
    default:
      next(action);
      break;
  }
};

export default customMiddleware;
